module.exports = __webpack_public_path__ + "img/gfx-step-2_x3.7048d072.webp";